'use client';

export { MultiTierGift, MultiTierGiftView } from '@eliadmin/core/src/components/product/detail/multi-tier-gift-base';
